let storeInstance = null;

export const attachStore = (store) => {
  storeInstance = store;
};

export const getStore = () => storeInstance;
